"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  "experience_pro": "+ de 20 ans",
  "nbre": 46,
  "tjm_moyen": 623
}, {
  "experience_pro": "11 à 20 ans",
  "nbre": 39,
  "tjm_moyen": 560
}, {
  "experience_pro": "2 à 5 ans",
  "nbre": 11,
  "tjm_moyen": 450
}, {
  "experience_pro": "6 à 10 ans",
  "nbre": 17,
  "tjm_moyen": 524
}, {
  "experience_pro": "Moins de 2 ans",
  "nbre": 7,
  "tjm_moyen": 382
}];
exports["default"] = _default;